@if (jobs.applications().length === 0) {
  <app-platform-jobs-empty-state
    [icon]="icons.briefcase"
    [title]="'jobboard.platform.jobs.applications.empty-title' | transloco"
    [text]="'jobboard.platform.jobs.applications.empty-text' | transloco"
    [ctaLabel]="'jobboard.platform.jobs.applications.empty-cta' | transloco"
    [ctaIcon]="icons.search"
    [ctaLink]="['/jobs']"
  />
} @else {
  <div class="segments">
    <ct-lib-segmented-control
      [items]="statusItems()"
      [selectedValue]="statusFilter()"
      (valueChange)="setStatusFilter($event)"
    />
  </div>
  <div class="segment-content">
    <div class="table-wrapper">
      <div class="actions">
        <ct-lib-table-search-input
          [placeholder]="'jobboard.platform.jobs.applications.search-placeholder'"
          (search)="onSearch($event)"
        />
      </div>
      @if (visibleApplications().length === 0) {
        <ct-lib-empty-placeholder
          [icon]="icons.briefcase"
          [title]="'jobboard.platform.jobs.applications.sub-empty-title' | transloco"
          [text]="'jobboard.platform.jobs.applications.sub-empty-text' | transloco"
        />
      } @else {
        <p-table
          [value]="visibleApplications()"
          dataKey="id"
          [rowTrackBy]="trackById"
          sortField="appliedAt"
          [sortOrder]="-1"
          [scrollable]="true"
          [scrollHeight]="'flex'"
        >
          <ng-template #header>
            <tr>
              <th class="table-date-column" pSortableColumn="appliedAt">
                {{ 'jobboard.platform.jobs.table.applied-at' | transloco }}
                <fa-icon class="sort" [icon]="icons.sort"></fa-icon>
                <fa-icon class="sortUp" [icon]="icons.sortUp"></fa-icon>
                <fa-icon class="sortDown" [icon]="icons.sortDown"></fa-icon>
              </th>
              <th pSortableColumn="jobTitle">
                {{ 'jobboard.platform.jobs.table.job' | transloco }}
                <fa-icon class="sort" [icon]="icons.sort"></fa-icon>
                <fa-icon class="sortUp" [icon]="icons.sortUp"></fa-icon>
                <fa-icon class="sortDown" [icon]="icons.sortDown"></fa-icon>
              </th>
              <th pSortableColumn="companyName">
                {{ 'jobboard.platform.jobs.table.company' | transloco }}
                <fa-icon class="sort" [icon]="icons.sort"></fa-icon>
                <fa-icon class="sortUp" [icon]="icons.sortUp"></fa-icon>
                <fa-icon class="sortDown" [icon]="icons.sortDown"></fa-icon>
              </th>
              <th class="d-none d-md-table-cell" pSortableColumn="status">
                {{ 'jobboard.platform.jobs.table.status' | transloco }}
                <fa-icon class="sort" [icon]="icons.sort"></fa-icon>
                <fa-icon class="sortUp" [icon]="icons.sortUp"></fa-icon>
                <fa-icon class="sortDown" [icon]="icons.sortDown"></fa-icon>
              </th>
              <th class="actions">{{ 'jobboard.platform.jobs.table.actions' | transloco }}</th>
            </tr>
          </ng-template>
          <ng-template #body let-application>
            <tr>
              <td class="table-date-column">
                {{ application.appliedAt | date: 'dd.MM.yyyy' }}
              </td>
              <td>
                <div class="cell-job">
                  @if (application.jobAvailable && application.jobUrl) {
                    <a
                      [href]="application.jobUrl"
                      target="_blank"
                      rel="noopener noreferrer"
                    >{{ application.jobTitle }}</a>
                  } @else {
                    <span>{{ application.jobTitle }}</span>
                  }
                </div>
              </td>
              <td>
                <div class="cell-company">
                  @if (companyBoardUrl(application); as companyUrl) {
                    <a
                      [href]="companyUrl"
                      target="_blank"
                      rel="noopener noreferrer"
                      [attr.aria-label]="'jobboard.platform.jobs.applications.open-company' | transloco"
                    >
                      <app-platform-company-logo
                        [companyName]="application.companyName"
                        [companyId]="application.companyId"
                        [small]="true"
                      />
                      <span>{{ application.companyName }}</span>
                    </a>
                  } @else {
                    <app-platform-company-logo
                      [companyName]="application.companyName"
                      [companyId]="application.companyId"
                      [small]="true"
                    />
                    <span>{{ application.companyName }}</span>
                  }
                </div>
              </td>
              <td class="d-none d-md-table-cell">
                <ct-lib-tag [variant]="statusTagVariant(application)">
                  {{ jobs.statusTranslationKey(application.status) | transloco }}
                  @if (jobs.hasActionItem(application)) {
                    <ct-lib-help-tooltip
                      [value]="missingDataTooltip(application)"
                      position="top"
                    />
                  }
                </ct-lib-tag>
              </td>
              <td class="actions">
                @if (jobs.hasActionItem(application)) {
                  <app-button
                    variant="white-grey"
                    (click)="openFollowUpChoice(application)"
                  >
                    {{ 'jobboard.platform.jobs.applications.complete-label' | transloco }}
                  </app-button>
                }
                <fa-icon
                  [icon]="icons.trash"
                  size="lg"
                  class="red"
                  [tooltip]="'jobboard.platform.jobs.applications.delete-aria' | transloco"
                  [attr.aria-label]="'jobboard.platform.jobs.applications.delete-aria' | transloco"
                  (click)="openDeleteModal(application)"
                ></fa-icon>
              </td>
            </tr>
          </ng-template>
        </p-table>
      }
    </div>
  </div>
}

<ct-lib-confirm-modal
  #deleteModal
  [label]="'jobboard.platform.jobs.applications.delete-title' | transloco"
  [confirmLabel]="'jobboard.platform.jobs.applications.delete-confirm' | transloco"
  [cancelLabel]="'jobboard.platform.jobs.applications.delete-cancel' | transloco"
  (onConfirm)="confirmDelete()"
>
  <p>{{ 'jobboard.platform.jobs.applications.delete-text' | transloco }}</p>
</ct-lib-confirm-modal>

<app-platform-follow-up-choice-modal
  #choiceModal
  (chooseManual)="openCompleteModal($event.id)"
/>

<app-platform-jobs-complete-modal
  #completeModal
  [application]="completingApplication()"
  (completed)="onCompleted()"
/>
